import {
  AREA_DETAILS,
  CITY_DETAILS,
  NEAREST_CITY_ENDPOINT,
  GET_ALL_CITY_BY_STATE_URL,
  GET_ALL_STATE_URL,
  NEAREST_ADDRESS_ENDPOINT,
} from "../constants";
import ApiCalls from "GlobalUtils/ApiCalls";
import { serialzeObjectToQueryString } from "GlobalUtils/Common";

const fetchArea = areaId => {
  return ApiCalls.fetchApi({
    url: AREA_DETAILS,
    options: { id: areaId },
    requestInit: { credentials: "same-origin" },
  });
};

const fetchCity = cityId => {
  return ApiCalls.fetchApi({ url: CITY_DETAILS + cityId });
};

const getLocation = (latitude, longitude) => {
  return ApiCalls.fetchApi({
    url: `${NEAREST_CITY_ENDPOINT}?${serialzeObjectToQueryString({
      latitude,
      longitude,
    })}`,
    requestInit: {
      method: "GET",
      credentials: "same-origin",
    },
  });
};

const fetchAllCityByState = stateId => {
  return ApiCalls.fetchApi({ url: GET_ALL_CITY_BY_STATE_URL + stateId });
};

const fetchAllState = () => {
  return ApiCalls.fetchApi({ url: GET_ALL_STATE_URL });
};

const getAddress = (latitude, longitude) => {
  return ApiCalls.fetchApi({
    url: `${NEAREST_ADDRESS_ENDPOINT}?${serialzeObjectToQueryString({
      latitude,
      longitude,
    })}`,
    requestInit: {
      method: "GET",
      credentials: "same-origin",
    },
  });
};

const LocationApi = {
  fetchArea,
  fetchCity,
  getLocation,
  fetchAllCityByState,
  fetchAllState,
  getAddress,
};

export default LocationApi;
